const IncludedPages = ['admin', 'workflows'];

class DesignV2API {
    constructor() {
        this.type = 'vue';
        this.pages = IncludedPages;
        this.exactRoutes = [];
        this.excludeRoutes = [];
        this.is_enable_new_design = false;
    }

    addExactPage = (page) => {
        const exist = this.exactRoutes.some((item) => item === page);
        if (exist) return;
        this.exactRoutes.push(page);
    };

    addPage = (page) => {
        const exist = this.pages.some((item) => item === page);
        if (exist) return;
        this.pages.push(page);
    };

    addExcludePage = (page) => {
        const exist = this.excludeRoutes.some((item) => item === page);
        if (exist) return;
        this.excludeRoutes.push(page);
    };

    init = (config) => {
        this.is_enable_new_design = Boolean(config?.is_enable_new_design);

        const is_v2_salesforce_page = Boolean(config?.salesmsg_design_v2_salesforce);
        const is_v2_calendly_page = Boolean(config?.salesmsg_design_v2_calendly_page);
        const is_v2_billing_upgrade_page = Boolean(config?.billing_upgrade_v2);
        const is_v2_billing_overview_page = Boolean(config?.billing_overview_v2);
        const is_v2_zoho_page = Boolean(config?.zoho_integration);
        const is_v2_webhook_page = Boolean(config?.webhook_setting);
        const is_v2_compliance_toll_free = Boolean(config?.salesmsg_design_v2_compliance_toll_free);
        const sign_up_v2 = Boolean(config?.sign_up_v2);
        const hubspot_workflow_statistics = Boolean(config?.hubspot_workflow_statistics);
        const is_v2_general_org_setting = Boolean(config?.salesmsg_design_v2_general_org_setting);
        const is_v2_email_to_sms_org_setting = Boolean(
            config?.salesmsg_design_v2_email_to_sms_org_setting
        );
        const settings_inboxes_manage_inbox_calling_v2 = Boolean(
            config?.settings_inboxes_manage_inbox_calling_v2
        );
        const search_results_page = Boolean(config?.search_results_page);
        const integrations_list_v2 = config?.integrations_list_v2
            ? String(config?.integrations_list_v2)
            : '';
        const is_v2_clients = Boolean(config?.salesmsg_design_v2_clients);
        const is_v2_teams = Boolean(config?.salesmsg_design_v2_teams);
        const is_v2_chat_widget_setting = Boolean(config?.chat_widget_setting_v2);
        const url_shortener_design_v2 = Boolean(config?.url_shortener_design_v2);

        if (this.is_enable_new_design) {
            this.addPage('conversations');
            this.addPage('discover');
            if (search_results_page) this.addPage('conversations/search');
            this.addPage('contacts');
            this.addPage('auth/reset');
            this.addPage('auth/accept');
            this.addPage('auth/agency');
            this.addPage('auth/oauth');
            this.addPage('register/multiorg');
            this.addPage('power-dialer');
            this.addExactPage('campaigns');
            this.addExactPage('settings/quick-links');
            this.addPage('settings/rcs');
            this.addPage('settings/saved-replies');
            this.addPage('settings/organization/add-ons');

            this.addExactPage('settings/organization/inboxes');
            this.addExactPage('settings/organization/inboxes/all-inboxes');
            this.addPage('settings/inboxes');

            this.addPage('settings/organization/members');
            this.addPage('settings/members');
            this.addPage('settings/roles-permissions');
            this.addPage('settings/system');

            this.addExactPage('settings/organization/inboxes/all-inboxes/\\d+');
            this.addExactPage('settings/organization/inboxes/all-inboxes/\\d+/members');
            this.addExactPage('settings/organization/inboxes/all-inboxes/\\d+/numbers');
            this.addExactPage('settings/organization/inboxes/all-inboxes/\\d+/settings');

            // teams
            if (is_v2_teams) {
                this.addPage('settings/organization/teams');
            }

            // numbers
            this.addPage('settings/organization/numbers');
            this.addPage('landline');

            // rag
            this.addPage('settings/knowledge-base');
            this.addPage('knowledge-base');

            // activecampaign
            this.addExactPage('settings/integrations/activecampaign/settings');

            if (is_v2_general_org_setting) {
                this.addPage('settings/organization/settings/double-opt-in');
            }

            if (is_v2_general_org_setting || is_v2_email_to_sms_org_setting) {
                this.addPage('settings/organization/settings/email-to-sms');
            }

            // compliance
            this.addPage('settings/organization/compliance');

            if (!is_v2_compliance_toll_free) {
                this.addExcludePage('settings/organization/compliance/toll-free/\\d+');
                this.addExcludePage('settings/organization/compliance/toll-free/view/\\d+');
            }

            this.addPage('broadcasts');
            this.addPage('triggers');
            this.addPage('analytics');

            this.addExactPage('settings/integrations');
            this.addExactPage('settings/integrations/(?!webhooks)[^/]+');
            this.addExactPage('settings/integrations/[^/]+/description');

            if (integrations_list_v2) {
                integrations_list_v2.split(',').forEach((key) => {
                    if (key === 'no') return;
                    this.addExactPage(`settings/integrations/${key}/settings`);
                });
            }

            this.addExactPage('settings/integrations/hubspot/settings');

            if (is_v2_salesforce_page) {
                this.addExactPage('settings/integrations/salesforce/settings');
            }
            if (is_v2_calendly_page) {
                this.addExactPage('settings/integrations/calendly/settings');
            }

            this.addExactPage('settings/integrations/infusionsoft/settings');
            this.addExactPage('settings/integrations/pipedrive/settings');
            this.addExactPage('settings/integrations/intercom/settings');
            this.addExactPage('settings/integrations/aircall/settings');
            this.addExactPage('settings/integrations/slack/settings');
            this.addExactPage('settings/integrations/salesmsg_mcp/settings');
            this.addExactPage('settings/integrations/agentforce/settings');
            this.addExactPage('settings/integrations/twilio-integration/settings');
            this.addExactPage('settings/integrations/google_calendar/settings');

            if (is_v2_webhook_page) {
                this.addPage('settings/integrations/webhooks');
            }
            if (is_v2_zoho_page) {
                this.addExactPage('settings/integrations/zoho/settings');
            }

            if (is_v2_billing_upgrade_page) {
                this.addExactPage('settings/billing/overview/upgrade(\\?.*)?');
                this.addExactPage('settings/upgrade');
            }

            if (is_v2_billing_overview_page) {
                this.addExactPage('settings/billing/overview(\\?.*)?');
                this.addExactPage('settings/billing(\\?.*)?');
            }

            this.addExactPage('settings/developer/applications');
            this.addExactPage('settings/developer/access-tokens');
            this.addExactPage('settings/personal/authorized-apps');

            this.addPage('keywords');
            this.addPage('click-to-text');
            this.addPage('campaigns');

            if (hubspot_workflow_statistics) this.addPage('hubspot-workflows');

            this.addPage('settings/organization/referrals');

            if (settings_inboxes_manage_inbox_calling_v2) {
                this.addExactPage('settings/organization/inboxes/all-inboxes/\\d+/calling');
            }

            this.addPage('settings/organization/custom-fields');
            this.addPage('settings/custom-fields');
            this.addPage('settings/organization/tags');
            this.addPage('settings/personal/settings/profile');
            this.addPage('settings/personal/settings/security');
            this.addPage('settings/personal/settings/voicemail-drop');
            this.addPage('settings/notifications');

            if (is_v2_clients) {
                this.addPage('clients');
                this.addPage('clients/create');
            }

            if (is_v2_chat_widget_setting) {
                this.addPage('settings/widget/chat');
            }

            if (url_shortener_design_v2) {
                this.addPage('settings/organization/custom-url-shortener');
            }

            this.addPage('surveys');
            this.addPage('reviews');
            this.addPage('suspended');
        }

        this.addPage('landing-mobile');
        this.addPage('chatbot');

        if (sign_up_v2) {
            this.addExactPage('register');
            if (window.location.search) this.addPage('register');
            this.addPage('auth/login');
            this.addPage('auth.login');
            this.addPage('auth/reset');
            this.addPage('auth/forgot');
            this.addPage('auth/accept');
            this.addPage('auth/agency');
        }

        this.key = this.handleCheckPage() ? 'new' : 'core';

        if (this.key === 'core') {
            this.applyCore();
        }

        if (this.key === 'new') {
            this.applyNew();
        }
    };

    initWatch = (value) => {
        if (this.handleCheckPage(value)) {
            this.applyNew();
        } else {
            this.applyCore();
        }
    };

    stripQuotes(text) {
        if (text[0] === '/') return text.slice(1);

        return text;
    }

    handleCheckPage = (page) => {
        page = page ? page : window.location.pathname.replace(/^\//, '');
        const pathname = `/${this.stripQuotes(page)}`;
        page = `${page}${window.location.search}`;
        page = this.stripQuotes(page);

        if (!this.is_enable_new_design) {
            this.pages = IncludedPages;
        }

        const regexPatternPages = `^(${this.pages.join('|')})`;
        const regexPages = new RegExp(regexPatternPages);

        const regexPatternExactRoutes = `^(${this.exactRoutes.join('|')})$`;
        const regexExactRoutes = new RegExp(regexPatternExactRoutes);

        const regexPatternExcludeRoutes = `^(${this.excludeRoutes.join('|')})$`;
        const regexExcludeRoutes = new RegExp(regexPatternExcludeRoutes);

        if (page.match(regexExcludeRoutes)) return false;

        const isReactPage =
            Boolean(page.match(regexPages)) || Boolean(page.match(regexExactRoutes));
        if (isReactPage) return true;

        if (!window.RouterVue) return false;

        const isKnownVuePage = window.RouterVue.resolve(pathname).matched.length > 0;

        return !isKnownVuePage;
    };

    applyCore = () => {
        document.querySelector('html').className = 'app-vue';
    };

    applyNew = () => {
        document.querySelector('html').className = 'app-react';
    };
}

export default DesignV2API;
